const PhoneInput = ({
  label,
  id,
  value,
  onChange,
  required = false,
  placeholder = '712345678',
  ...props
}) => {
  const getInputValue = () => {
    if (!value) return ''

    return value.startsWith('+254') ? value.slice(4) : value
  }

  const onPhoneChange = (e) => {
    const newValue = e.target.value
    if (newValue.startsWith('0')) {
      onChange(`+254${newValue.slice(1)}`)
      return
    }

    if (!newValue.startsWith('+254')) {
      onChange(`+254${newValue}`)
      return
    }

    onChange(newValue)
  }

  return (
    <div className="space-y-2">
      <label
        htmlFor={id}
        className="flex items-center text-sm font-medium text-foreground-muted font-inter"
      >
        {label}
        {required && <span className="text-error-900 ml-1">*</span>}
      </label>

      <div className="relative">
        <input
          type="tel"
          id={id}
          name={id}
          value={getInputValue()}
          onChange={onPhoneChange}
          required={required}
          placeholder={placeholder}
          className={`block w-full h-10 pl-14 pr-3 py-2 bg-secondary-50 border rounded-md text-sm font-medium text-foreground font-inter placeholder:text-gray-400 focus:outline-none transition-colors border-gray-200 focus:border-secondary-600 focus:ring-1 focus:ring-secondary-600/20`}
          {...props}
        />

        <div className="absolute left-3 top-[48%] transform -translate-y-1/2 pointer-events-none ">
          <span className="text-sm text-gray-600 font-medium">+254</span>
        </div>
      </div>
    </div>
  )
}

export default PhoneInput
